import script from "./WritingBoardTool.vue?vue&type=script&lang=ts&setup=true"
export * from "./WritingBoardTool.vue?vue&type=script&lang=ts&setup=true"

import "./WritingBoardTool.vue?vue&type=style&index=0&id=1171e178&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1171e178"]])

export default __exports__